import MemberCard from './MemberCard.component';

export default MemberCard;